export var InputRelatedVariantType;
(function (InputRelatedVariantType) {
    /**
     * @deprecated
     * This variant will be removed, use REGULAR variant instead
     */
    InputRelatedVariantType["DEFAULT"] = "DEFAULT";
    InputRelatedVariantType["REGULAR"] = "REGULAR";
})(InputRelatedVariantType || (InputRelatedVariantType = {}));
export var InputRelatedStateType;
(function (InputRelatedStateType) {
    InputRelatedStateType["DEFAULT_EMPTY"] = "DEFAULT_EMPTY";
    InputRelatedStateType["DEFAULT_FILLED"] = "DEFAULT_FILLED";
    InputRelatedStateType["ACTIVE_EMPTY"] = "ACTIVE_EMPTY";
    InputRelatedStateType["ACTIVE_FILLED"] = "ACTIVE_FILLED";
    InputRelatedStateType["ERROR_EMPTY"] = "ERROR_EMPTY";
    InputRelatedStateType["ERROR_FILLED"] = "ERROR_FILLED";
    InputRelatedStateType["DISABLED_EMPTY"] = "DISABLED_EMPTY";
    InputRelatedStateType["DISABLED_FILLED"] = "DISABLED_FILLED";
})(InputRelatedStateType || (InputRelatedStateType = {}));
//# sourceMappingURL=variants.js.map